import Link from 'next/link';
import styled from 'styled-components';

import { BuyBarGlobalPricingInfo } from 'productTemplate/components/buyBar/styles/BuyBarStyles';
import { Update2022VariantGrid } from 'productTemplate/components/buyBar/Update2022VariantGrid';
import { Update2022VariantSectionContentHeader } from 'productTemplate/components/buyBar/variantSectionContentHeaders/Update2022VariantSectionContentHeader';
import { Stack } from 'shared/components/Stack';
import { variableFontRegular } from 'styles/theme/text';
import { IProductSearch } from 'shared/types/ProductSearch';
import { t } from 'localization/utils/t';

const TP =
  'productTemplate.components.buyBar.VariantSectionContent.Update2022VariantSectionContent';

export interface IUpdate2022VariantSectionContentProps {
  className?: string;
  variants?: IProductSearch[];
  title?: string;
  onClose?: () => void;
}

export const Update2022VariantSectionContent = ({
  variants,
  title,
  onClose,
  ...rest
}: IUpdate2022VariantSectionContentProps) => (
  <Update2022VariantSectionContent.Stack {...rest} direction="column">
    {title && (
      <Update2022VariantSectionContent.Header onBack={onClose}>
        {title}
      </Update2022VariantSectionContent.Header>
    )}

    <Link href="/verification" passHref prefetch={false} legacyBehavior>
      <Update2022VariantSectionContent.AuthenticityLink
        target="_blank"
        rel="noopener noreferrer"
        $hasTitle={Boolean(title)}
      >
        {t(`${TP}.authenticityAssured`, 'Authenticity Assured')}
      </Update2022VariantSectionContent.AuthenticityLink>
    </Link>

    <BuyBarGlobalPricingInfo location="used_pdp" />

    <Update2022VariantSectionContent.Grid variants={variants} isLoading={!variants} />
  </Update2022VariantSectionContent.Stack>
);

Update2022VariantSectionContent.Stack = styled(Stack)`
  flex-grow: 1;
`;

Update2022VariantSectionContent.Header = styled(Update2022VariantSectionContentHeader)`
  position: sticky;
  top: 0px;

  // NOTE: Because we make the header sticky, we want to apply any background
  //       value that may have been set in a parent component so things look
  //       appropriate on scroll
  //
  // REF: https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_custom_properties
  background: var(--local-background);
`;

Update2022VariantSectionContent.AuthenticityLink = styled.a<{ $hasTitle: boolean }>`
  margin: ${({ $hasTitle }) => ($hasTitle ? '8px' : '24px')} auto 8px;
  text-align: center;

  ${variableFontRegular({ size: '11.5px', height: '11px' })}
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    display: none;
  }
`;

Update2022VariantSectionContent.Grid = styled(Update2022VariantGrid)`
  margin: 24px 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    margin: 16px auto auto;
  }
`;
